export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = 'en';
export const LANGUAGE_STORAGE_KEY = 'app-language';

export function isLanguage(value: unknown): value is Language {
	return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** Stored choice first, then the browser, then English. Unknown stored values are ignored. */
export function resolveInitialLanguage(input: {
	stored: string | null;
	navigatorLanguage: string | undefined;
}): Language {
	if (isLanguage(input.stored)) return input.stored;
	if (input.navigatorLanguage?.toLowerCase().startsWith('de')) return 'de';
	return DEFAULT_LANGUAGE;
}
